<template>
  <div class="placement-container">
    <el-card shadow="never" style="border-radius: 8px">
      <!-- 搜索操作栏 -->
      <div style="margin-bottom: 24px">
        <el-row type="flex" justify="space-between" align="middle">
          <!-- 左侧：搜索与筛选 -->
          <div style="display: flex; gap: 12px; align-items: center">
            <el-input
              v-model="query.name"
              placeholder="请输入名称"
              clearable
              style="width: 200px"
              @keyup.enter.native="handleSearch"
            />
            <el-button
              type="primary"
              icon="el-icon-search"
              @click="handleSearch"
            >搜索</el-button>
            <el-button
              icon="el-icon-refresh"
              @click="handleReset"
            >重置</el-button>
          </div>
          <!-- 右侧：新增 -->
          <div>
            <el-button
              type="primary"
              icon="el-icon-plus"
              @click="handleAdd"
            >新增</el-button>
          </div>
        </el-row>
      </div>

      <!-- 表格 -->
      <el-table
        v-loading="loading"
        :data="tableData"
        stripe
        border
        style="width: 100%"
        :header-cell-style="{ background: '#F5F7FA' }"
      >
        <el-table-column prop="id" label="ID" align="center" width="80" />
        <el-table-column prop="name" label="名称" align="center" />
        <el-table-column prop="roi_coefficient" label="ROI系数" align="center" />
        <el-table-column prop="created_at_text" label="创建时间" align="center" />
        <el-table-column label="操作" align="center" width="150">
          <template slot-scope="scope">
            <el-button
              type="warning"
              size="mini"
              @click="handleEdit(scope.row)"
            >编辑</el-button>
            <!-- <el-button
              type="danger"
              size="mini"
              @click="handleDelete(scope.row)"
            >删除</el-button> -->
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div style="margin-top: 16px; text-align: right">
        <el-pagination
          background
          layout="prev, pager, next, jumper, total"
          :total="total"
          :page-size="query.page_size"
          :current-page.sync="query.page"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        />
      </div>
    </el-card>

    <!-- 新增/编辑弹窗 -->
    <placement-dialog
      ref="placementDialog"
      @refresh="getList"
    />
  </div>
</template>

<script>
import { placementList, placementDelete } from '@/api/notify.js'
import PlacementDialog from './components/placementDialog.vue'

export default {
  name: 'Placement',
  components: {
    PlacementDialog
  },
  data() {
    return {
      // 查询参数
      query: {
        name: '',
        page: 1,
        page_size: 10
      },
      // 列表数据
      tableData: [],
      // 总条数
      total: 0,
      // 加载状态
      loading: false
    }
  },
  created() {
    this.getList()
  },
  methods: {
    // 获取列表
    async getList() {
      this.loading = true
      try {
        const res = await placementList({ ...this.query })
        if (res && res.success) {
          this.tableData = res.data.list || []
          this.total = res.data.total || 0
        } else {
          this.$message.error(res.message || '获取数据失败')
        }
      } catch (err) {
        console.error(err)
        this.$message.error('请求失败，请稍后重试')
      } finally {
        this.loading = false
      }
    },
    // 搜索
    handleSearch() {
      this.query.page = 1
      this.getList()
    },
    // 重置
    handleReset() {
      this.query.name = ''
      this.query.page = 1
      this.getList()
    },
    // 新增
    handleAdd() {
      this.$refs.placementDialog.open(1)
    },
    // 编辑
    handleEdit(row) {
      this.$refs.placementDialog.open(2, row)
    },
    // 删除
    handleDelete(row) {
      this.$confirm(`确定删除【${row.name}】吗？`, '提示', {
        type: 'warning'
      })
        .then(async() => {
          try {
            const res = await placementDelete({ id: row.id })
            if (res && res.success) {
              this.$message.success('删除成功')
              this.getList()
            } else {
              this.$message.error(res.message || '删除失败')
            }
          } catch (err) {
            console.error(err)
            this.$message.error('删除请求失败')
          }
        })
        .catch(() => {
          /* 用户取消 */
        })
    },
    // 分页
    handleSizeChange(size) {
      this.query.page_size = size
      this.getList()
    },
    handleCurrentChange(page) {
      this.query.page = page
      this.getList()
    }
  }
}
</script>

<style scoped>
.placement-container {
  padding: 24px;
}
</style>
